module.exports = __webpack_public_path__ + "static/media/times-hexagon.e1034acb.svg";